document.addEventListener("DOMContentLoaded", () => {

  const cards = document.querySelectorAll(".nook-cause-card");

  if (!cards.length) return;

  const reward = document.getElementById("NookPdpReward");
  const amount = document.getElementById("NookPdpAmount");
  const description = document.getElementById("NookPdpDescription");
 

  const DISCOUNT_PER_PRODUCT = 5000;

  //==========================================
  // Obtener cantidad
  //==========================================

  function getQuantity() {

    const input = document.querySelector('input[name="quantity"]');

    return input ? parseInt(input.value) || 1 : 1;

  }

  //==========================================
  // Actualizar descuento
  //==========================================

function updateReward() {

  const selected = document.querySelector(".nook-cause-card.is-selected");

  if (selected && selected.dataset.foundation === "none") {

    amount.innerHTML = "$0";
    code.innerHTML = "-";
    reward.hidden = true;

    localStorage.removeItem("nookDiscountCode");

    return;
  }

  const qty = getQuantity();
  const total = qty * DISCOUNT_PER_PRODUCT;
  const discountCode = "PROPOSITO" + (total / 1000);

  amount.innerHTML = "-$" + total.toLocaleString("es-CO");
  code.innerHTML = "-";

  // GUARDA SIEMPRE EL CÓDIGO ACTUAL
  localStorage.setItem("nookDiscountCode", discountCode);
  console.log("NOOK CUPON:", discountCode);

  reward.hidden = false;

}

  //==========================================
  // Seleccionar fundación
  //==========================================

  function selectCard(card) {

    cards.forEach(c => c.classList.remove("is-selected"));

    card.classList.add("is-selected");

    const foundation = card.dataset.foundation;

    // ---------------------------------------
    // NO PARTICIPAR
    // ---------------------------------------

    if (foundation === "none") {

  if (foundation === "none") {

  localStorage.setItem("nookFoundation", JSON.stringify({

    slug: "none",

    nombre: "No participar",

    descripcion: "Comprarás al precio normal sin generar una donación.",

    logo: ""

  }));

  localStorage.removeItem("nookDiscountCode");

  document.dispatchEvent(
    new CustomEvent("nook:foundation-updated")
  );

  reward.hidden = true;

  amount.innerHTML = "$0";

  description.innerHTML =
    "Comprarás al precio normal sin generar una donación.";

  return;

}

    }

    // ---------------------------------------
    // GUARDAR OBJETO COMPLETO
    // ---------------------------------------

    const foundationData = {

      slug: foundation,

      nombre:
        card.querySelector("h4")?.textContent.trim() || "",

      descripcion:
        card.querySelector("p")?.textContent.trim() || "",

      logo:
        card.querySelector("img")?.src || ""

    };

    localStorage.setItem(
  "nookFoundation",
  JSON.stringify(foundationData)
);

document.dispatchEvent(
  new CustomEvent("nook:foundation-updated")
);

description.innerHTML =
  "Gracias ❤️ NOOK realizará una donación en nombre de tu compra.";

updateReward();

  }

  //==========================================
  // Click tarjetas
  //==========================================

  cards.forEach(card => {

    card.addEventListener("click", () => {

      selectCard(card);

    });

  });

  //==========================================
  // Restaurar selección
  //==========================================

  const saved = localStorage.getItem("nookFoundation");

  if (saved) {

    try {

      const foundation = JSON.parse(saved);

      const previous = document.querySelector(
        `[data-foundation="${foundation.slug}"]`
      );

      if (previous) {

        selectCard(previous);

      }

    } catch(e){

      console.error(e);

    }

  }

  //==========================================
  // Cambios de cantidad
  //==========================================

  document.addEventListener("click", function (e) {

    if (
      e.target.closest('[name="plus"]') ||
      e.target.closest('[name="minus"]') ||
      e.target.closest('input[name="quantity"]')
    ) {

      setTimeout(updateReward,150);

    }

  });


  //==========================================
  // Inicializar
  //==========================================

  updateReward();

});